// internal-deps
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { IColors } from "@swiggy-private/dls-web-common/dist/components/types.internal";

// helpers
import { getStatusBannerMaxHeight } from "@dineout-payment-success-ui/helpers/index";

// styles
import styled from "styled-components";

interface IColorKey {
    colorKey: keyof IColors;
    textColor?: string;
}

const MAX_WIDTH = "500px";
const BANNER_IMAGE_HEIGHT_MARGIN_TOP = 60;
const BANNER_IMAGE_DIMENSIONS = {
    height: 62,
    width: 62,
};

export const StatusBannerWrapper = styled.div<{
    showStatusDescription: boolean;
}>(({ showStatusDescription }) => ({
    textAlign: "center",
    maxHeight: getStatusBannerMaxHeight(showStatusDescription, false, false, false),
    overflow: "hidden",
}));

export const StatusText = styled(Text)<IColorKey>(({ textColor, colorKey, theme }) => ({
    color: textColor || theme.colors[theme.colorMode][colorKey],
}));

export const TextContentWrapper = styled.div(({ theme }) => ({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: theme.spacing.xLarge,
    marginTop: theme.spacing.small,
}));

export const StyledImage = styled(Image)({
    height: "100%",
    objectFit: "cover",
    width: "100%",
});

export const RedemptionInstructionSubtext = styled(Text)<IColorKey>(({ textColor, colorKey, theme }) => ({
    width: "70%",
    color: textColor || theme.colors[theme.colorMode][colorKey],
}));

export const SubtextWrapper = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.xSmall,
    alignItems: "center",
}));

export const BookingIdText = styled(Text)(({ theme }) => ({
    marginTop: theme.spacing.medium,
}));

export const BgContainer = styled.div(() => ({
    height: BANNER_IMAGE_DIMENSIONS.height,
    width: BANNER_IMAGE_DIMENSIONS.width,
    maxWidth: MAX_WIDTH,
    margin: `${BANNER_IMAGE_HEIGHT_MARGIN_TOP}px auto 0`,
}));
